module.exports = __webpack_public_path__ + "static/banner-img-1-0c9044791e250ab8a768da1431998f4a.jpg";